import { Link } from 'react-router-dom'
import AuthLayout from '@/components/auth/AuthLayout'
import RegisterForm from '@/components/auth/RegisterForm'

const Register = () => {
  return (
    <AuthLayout
      title="Registrierung"
      description="Erstellen Sie Ihr Herzensempfehlung-Konto und starten Sie in 2 Minuten"
    >
      <RegisterForm />
      
      <div className="mt-6 text-center">
        <p className="text-sm text-muted-foreground">
          Bereits ein Konto?{' '}
          <Link to="/anmelden" className="text-primary hover:underline font-medium">
            Jetzt anmelden
          </Link>
        </p>
      </div>
      
      <div className="mt-4 p-3 bg-accent/10 rounded-lg">
        <p className="text-xs text-center text-muted-foreground">
          14 Tage kostenlos testen • Keine Kreditkarte erforderlich
        </p>
      </div>
    </AuthLayout>
  )
}

export default Register